import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import FeatherIcon from "feather-icons-react";
import avatar1 from "../../assets/images/users/user-dummy-img.jpg";

const ProfileDropdown = () => {
    const [profile, setProfile] = useState(null);
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);

    useEffect(() => {
        const authUser = sessionStorage.getItem("authUser");
        if (authUser) {
            const parsed = JSON.parse(authUser);
            setProfile(parsed.user);
        }
    }, []);

    const toggleProfileDropdown = () => setIsProfileDropdown(!isProfileDropdown);

    const initials = (profile?.username || "U").slice(0, 2).toUpperCase();

    return (
        <React.Fragment>
            <style>{`
                .profile-dropdown-menu {
                    min-width: 240px;
                    padding: 6px;
                    border: 1px solid var(--vz-border-color) !important;
                    border-radius: 12px !important;
                    box-shadow: 0 8px 24px rgba(0,0,0,.12) !important;
                    background: var(--vz-secondary-bg) !important;
                }
                .profile-menu-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 9px 12px;
                    border-radius: 8px;
                    font-size: 13px;
                    font-weight: 500;
                    color: var(--vz-body-color);
                    text-decoration: none;
                    transition: background .15s;
                    cursor: pointer;
                }
                .profile-menu-item:hover {
                    background: rgba(var(--vz-primary-rgb), .08);
                    color: var(--vz-primary);
                    text-decoration: none;
                }
                .profile-menu-item:hover .profile-menu-icon {
                    color: var(--vz-primary);
                }
                .profile-menu-icon {
                    color: var(--vz-secondary-color);
                    flex-shrink: 0;
                    transition: color .15s;
                }
                .profile-menu-item.logout:hover {
                    background: rgba(var(--vz-danger-rgb), .08);
                    color: var(--vz-danger);
                }
                .profile-menu-item.logout:hover .profile-menu-icon {
                    color: var(--vz-danger);
                }
                .profile-divider {
                    height: 1px;
                    background: var(--vz-border-color);
                    margin: 6px 0;
                }
            `}</style>

            <Dropdown
                isOpen={isProfileDropdown}
                toggle={toggleProfileDropdown}
                className="ms-sm-3 header-item topbar-user"
            >
                {/* ── Toggle button ── */}
                <DropdownToggle tag="button" type="button" className="btn" style={{ padding: "4px 8px" }}>
                    <span className="d-flex align-items-center gap-2">
                        {profile?.user_image ? (
                            <img
                                className="rounded-circle header-profile-user"
                                src={profile.user_image}
                                onError={e => { e.target.src = avatar1; }}
                                alt="Avatar"
                                style={{ width: 34, height: 34, objectFit: "cover" }}
                            />
                        ) : (
                            <div style={{ width: 34, height: 34, borderRadius: "50%", background: "var(--vz-primary)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "#fff", flexShrink: 0 }}>
                                {initials}
                            </div>
                        )}
                        <span className="d-none d-xl-flex flex-column text-start" style={{ lineHeight: 1.3 }}>
                            <span style={{ fontSize: 13, fontWeight: 600, color: "var(--vz-body-color)" }}>
                                {profile?.username || "User"}
                            </span>
                            <span style={{ fontSize: 11, color: "var(--vz-secondary-color)" }}>
                                {profile?.role || profile?.company_name || ""}
                            </span>
                        </span>
                    </span>
                </DropdownToggle>

                {/* ── Dropdown menu ── */}
                <DropdownMenu className="dropdown-menu-end profile-dropdown-menu">

                    {/* User info header */}
                    <div style={{ padding: "10px 12px 12px", marginBottom: 4 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            {profile?.user_image ? (
                                <img
                                    src={profile.user_image}
                                    onError={e => { e.target.src = avatar1; }}
                                    alt="Avatar"
                                    style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
                                />
                            ) : (
                                <div style={{ width: 40, height: 40, borderRadius: "50%", background: "var(--vz-primary)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 700, color: "#fff", flexShrink: 0 }}>
                                    {initials}
                                </div>
                            )}
                            <div style={{ minWidth: 0 }}>
                                <p style={{ fontSize: 13, fontWeight: 700, color: "var(--vz-body-color)", margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {profile?.username || "User"}
                                </p>
                                <p style={{ fontSize: 11, color: "var(--vz-secondary-color)", margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {profile?.email || profile?.company_name || ""}
                                </p>
                            </div>
                        </div>
                        {/* Role badge */}
                        {profile?.role && (
                            <div style={{ marginTop: 8 }}>
                                <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 10px", borderRadius: 20, background: "rgba(var(--vz-primary-rgb),.1)", color: "var(--vz-primary)", border: "1px solid rgba(var(--vz-primary-rgb),.2)", textTransform: "uppercase", letterSpacing: ".04em" }}>
                                    {profile.role}
                                </span>
                            </div>
                        )}
                    </div>

                    <div className="profile-divider" />

                    {/* Profile */}
                    <Link
                        to={process.env.PUBLIC_URL + "/profile"}
                        className="profile-menu-item"
                        onClick={() => setIsProfileDropdown(false)}
                    >
                        <FeatherIcon icon="user" size={15} className="profile-menu-icon" />
                        My Profile
                    </Link>

                    {/* ── Settings — commented out (not implemented) */}
                    {/* <Link to={process.env.PUBLIC_URL + "#"} className="profile-menu-item" onClick={() => setIsProfileDropdown(false)}>
                        <FeatherIcon icon="settings" size={15} className="profile-menu-icon" />
                        Settings
                    </Link> */}

                    {/* ── Help — commented out (not implemented) */}
                    {/* <Link to={process.env.PUBLIC_URL + "#"} className="profile-menu-item" onClick={() => setIsProfileDropdown(false)}>
                        <FeatherIcon icon="help-circle" size={15} className="profile-menu-icon" />
                        Help
                    </Link> */}

                    <div className="profile-divider" />

                    {/* Logout */}
                    <Link
                        to={process.env.PUBLIC_URL + "/logout"}
                        className="profile-menu-item logout"
                        onClick={() => setIsProfileDropdown(false)}
                    >
                        <FeatherIcon icon="log-out" size={15} className="profile-menu-icon" />
                        Sign Out
                    </Link>

                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;